import { companyName, companyGSTIN, companyAddress } from "../../../app/store/constant";
import { FooterLogo } from "../../../assets/images";
import { H3, H4, H5, H6, H7, Body2, Body3 } from "../../../themes/typography";
import "./ShmoozToUserInvoice.css";

export default function ShmoozToUserInvoice() {
    return (
        <main id="a4-page">

            <header id="invoice-header-container">
                <div className="invoice-header">
                    <div className="invoice-logo">
                        <img src={FooterLogo} alt="Company Logo" />
                    </div>
                </div>
            </header>

            {/* <!-- <div className="invoice-details"></div> --> */}
            <table width="100%" style={{ background: 'var(--white-color)' }}>

                {/* <!-- Behind Header Empty Space --> */}
                <thead>
                    <tr>
                        <td>
                            <div className="header-space"></div>
                        </td>
                    </tr>
                </thead>

                <tbody>
                    <tr>
                        <td>

                            {/* <!-- Page 1 --> */}
                            <div className="page page-break-after-always">
                                <section className="tax-invoice-container">

                                    <div className="invoice-title">
                                        <H3 color="var(--primary-color)" fontWeight={700}>
                                            Tax Invoice
                                        </H3>
                                    </div>

                                    {/* <!-- Issued Persons Details --> */}
                                    <div className="tax-invoice-persons-container">
                                        <div className="issue-by-container">
                                            <H6 color="var(--primary-color)" fontWeight={400}>
                                                Invoice To:
                                            </H6>

                                            <div className="issue-by-details">

                                                <H5 color="var(--primary-color)" fontWeight={600}>
                                                    Prashant Chaute
                                                </H5>

                                                <div className="invoice-detail-container">
                                                    <div className="field-label">
                                                        <H6 color="var(--primary-color)" fontWeight={400}>
                                                            Email Id:
                                                        </H6>
                                                    </div>
                                                    <div className="field-value">
                                                        <H6 color="var(--primary-color)" fontWeight={400}>
                                                            email@email.com
                                                        </H6>
                                                    </div>
                                                </div>

                                                <div className="invoice-detail-container">
                                                    <div className="field-label">
                                                        <H6 color="var(--primary-color)" fontWeight={400}>
                                                            Phone No:
                                                        </H6>
                                                    </div>
                                                    <div className="field-value">
                                                        <H6 color="var(--primary-color)" fontWeight={400}>
                                                            9209203569
                                                        </H6>
                                                    </div>
                                                </div>

                                                <div className="invoice-detail-container">
                                                    <div className="field-label">
                                                        <H6 color="var(--primary-color)" fontWeight={400}>
                                                            State:
                                                        </H6>
                                                    </div>
                                                    <div className="field-value">
                                                        <H6 color="var(--primary-color)" fontWeight={400}>
                                                            Gujarat
                                                        </H6>
                                                    </div>
                                                </div>

                                            </div>
                                        </div>

                                        <div className="issue-by-container">
                                            <H6 color="var(--primary-color)" fontWeight={400}>
                                                Issued By:
                                            </H6>

                                            <div className="issue-by-details">

                                                <H5 color="var(--primary-color)" fontWeight={600}>
                                                    Shmooz Social LLP
                                                </H5>

                                                <div className="invoice-detail-container" style={{ gap: '0.5rem' }}>
                                                    <div className="field-label">
                                                        <H6 color="var(--primary-color)" fontWeight={400}>
                                                            GSTIN:
                                                        </H6>
                                                    </div>
                                                    <div className="field-value">
                                                        <H6 color="var(--primary-color)" fontWeight={400}>
                                                            1234567890ABCDE / NA
                                                        </H6>
                                                    </div>
                                                </div>

                                                <div className="invoice-detail-container" style={{ gap: '0.5rem' }}>
                                                    <div className="field-label">
                                                        <H6 color="var(--primary-color)" fontWeight={400}>
                                                            Address:
                                                        </H6>
                                                    </div>
                                                    <div className="field-value">
                                                        <H6 color="var(--primary-color)" fontWeight={400}>
                                                            123, Sample Address, Sample Area,
                                                            Sample Landmark, Surat - 395007
                                                        </H6>
                                                    </div>
                                                </div>

                                                <div className="company-city-state-container">
                                                    <div className="invoice-detail-container">
                                                        <div className="city-label">
                                                            <H6 color="var(--primary-color)" fontWeight={400}>
                                                                City:
                                                            </H6>
                                                        </div>
                                                        <div className="field-value">
                                                            <H6 color="var(--primary-color)" fontWeight={400}>
                                                                Surat
                                                            </H6>
                                                        </div>
                                                    </div>

                                                    <div className="invoice-detail-container">
                                                        <div className="city-label">
                                                            <H6 color="var(--primary-color)" fontWeight={400}>
                                                                State:
                                                            </H6>
                                                        </div>
                                                        <div className="field-value">
                                                            <H6 color="var(--primary-color)" fontWeight={400}>
                                                                Gujarat
                                                            </H6>
                                                        </div>
                                                    </div>
                                                </div>

                                            </div>
                                        </div>
                                    </div>

                                    <div className="hr"></div>

                                    {/* <!-- Invoice Details --> */}
                                    <div className="invoice-details-container">
                                        <H4 color="var(--primary-color)" fontWeight={600}>
                                            Invoice Details
                                        </H4>

                                        <div className="tax-invoice-persons-container">
                                            <div className="issue-by-container">

                                                <div className="issue-by-details">

                                                    <div className="invoice-detail-container">
                                                        <div className="field-label">
                                                            <H6 color="var(--primary-color)" fontWeight={400}>
                                                                Invoice No.:
                                                            </H6>
                                                        </div>
                                                        <div className="field-value">
                                                            <H6 color="var(--primary-color)" fontWeight={400}>
                                                                INV-0001
                                                            </H6>
                                                        </div>
                                                    </div>

                                                    <div className="invoice-detail-container">
                                                        <div className="field-label">
                                                            <H6 color="var(--primary-color)" fontWeight={400}>
                                                                SAC Code:
                                                            </H6>
                                                        </div>
                                                        <div className="field-value">
                                                            <H6 color="var(--primary-color)" fontWeight={400}>
                                                                998314
                                                            </H6>
                                                        </div>
                                                    </div>

                                                    <div className="invoice-detail-container">
                                                        <div className="field-label">
                                                            <H6 color="var(--primary-color)" fontWeight={400}>
                                                                Place of supply:
                                                            </H6>
                                                        </div>
                                                        <div className="field-value">
                                                            <H6 color="var(--primary-color)" fontWeight={400}>
                                                                Gujarat
                                                            </H6>
                                                        </div>
                                                    </div>

                                                </div>
                                            </div>

                                            <div className="issue-by-container">

                                                <div className="issue-by-details">

                                                    <div className="invoice-detail-container">
                                                        <div className="field-label">
                                                            <H6 color="var(--primary-color)" fontWeight={400}>
                                                                Date of issue:
                                                            </H6>
                                                        </div>
                                                        <div className="field-value">
                                                            <H6 color="var(--primary-color)" fontWeight={400}>
                                                                01/01/2024
                                                            </H6>
                                                        </div>
                                                    </div>

                                                    <div className="invoice-detail-container">
                                                        <div className="service-desc-label">
                                                            <H6 color="var(--primary-color)" fontWeight={400}>
                                                                Service description:
                                                            </H6>
                                                        </div>
                                                        <div className="field-value">
                                                            <H6 color="var(--primary-color)" fontWeight={400}>
                                                                If code is applied
                                                            </H6>
                                                        </div>
                                                    </div>

                                                    <div className="invoice-detail-container">
                                                        <div className="field-label">
                                                            <H6 color="var(--primary-color)" fontWeight={400}>
                                                                Reverse charges applicable:
                                                            </H6>
                                                        </div>
                                                        <div className="field-value">
                                                            <H6 color="var(--primary-color)" fontWeight={400}>
                                                                No
                                                            </H6>
                                                        </div>
                                                    </div>

                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                    <div className="hr"></div>

                                    {/* <!-- Event Details --> */}
                                    <div className="invoice-details-container">
                                        <H4 color="var(--primary-color)" fontWeight={600}>
                                            Event Details
                                        </H4>

                                        <div className="tax-invoice-persons-container">
                                            <div className="issue-by-container">

                                                <div className="issue-by-details">

                                                    <div className="invoice-detail-container">
                                                        <div className="field-label">
                                                            <H6 color="var(--primary-color)" fontWeight={400}>
                                                                Event:
                                                            </H6>
                                                        </div>
                                                        <div className="field-value">
                                                            <a href="https://example.com" target="_blank"
                                                                rel="noopener noreferrer">
                                                                <H6 color="var(--primary-color)" fontWeight={400}>
                                                                    Sample Event Name
                                                                </H6>
                                                            </a>
                                                        </div>
                                                    </div>

                                                    <div className="invoice-detail-container">
                                                        <div className="field-label">
                                                            <H6 color="var(--primary-color)" fontWeight={400}>
                                                                Venue:
                                                            </H6>
                                                        </div>
                                                        <div className="field-value">
                                                            <a href="https://example.com" target="_blank"
                                                                rel="noopener noreferrer">
                                                                <H6 color="var(--primary-color)" fontWeight={400}>
                                                                    123, Sample Address, Sample City, Sample State, 123456
                                                                </H6>
                                                            </a>
                                                        </div>
                                                    </div>

                                                    <div className="invoice-detail-container">
                                                        <div className="field-label">
                                                            <H6 color="var(--primary-color)" fontWeight={400}>
                                                                Organizer:
                                                            </H6>
                                                        </div>
                                                        <div className="field-value">
                                                            <H6 color="var(--primary-color)" fontWeight={400}>
                                                                Sample Organizer Name
                                                            </H6>
                                                        </div>
                                                    </div>

                                                </div>
                                            </div>

                                            <div className="issue-by-container">

                                                <div className="issue-by-details">

                                                    <div className="invoice-detail-container">
                                                        <div className="field-label">
                                                            <H6 color="var(--primary-color)" fontWeight={400}>
                                                                Date:
                                                            </H6>
                                                        </div>
                                                        <div className="field-value">
                                                            <H6 color="var(--primary-color)" fontWeight={400}>
                                                                01/01/2024
                                                            </H6>
                                                        </div>
                                                    </div>

                                                    <div className="invoice-detail-container">
                                                        <div className="field-label">
                                                            <H6 color="var(--primary-color)" fontWeight={400}>
                                                                Time:
                                                            </H6>
                                                        </div>
                                                        <div className="field-value">
                                                            <H6 color="var(--primary-color)" fontWeight={400}>
                                                                07:00 PM
                                                            </H6>
                                                        </div>
                                                    </div>

                                                    {/* <!-- <div className="invoice-detail-container">
                                                    <div className="field-label">
                                                        <H6 color="var(--primary-color)" fontWeight={400}>
                                                            Duration:
                                                        </H6>
                                                    </div>
                                                    <div className="field-value">
                                                        <H6 color="var(--primary-color)" fontWeight={400}>
                                                            2 hours
                                                        </H6>
                                                    </div>
                                                </div> --> */}

                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                    <div className="hr"></div>

                                    {/* <!-- Booking Details --> */}
                                    <div className="invoice-details-container">
                                        <H4 color="var(--primary-color)" fontWeight={600}>
                                            Booking Details
                                        </H4>

                                        <div className="tax-invoice-persons-container">
                                            <div className="issue-by-container">

                                                <div className="issue-by-details">

                                                    <div className="invoice-detail-container">
                                                        <div className="field-label">
                                                            <H6 color="var(--primary-color)" fontWeight={400}>
                                                                Booking Id:
                                                            </H6>
                                                        </div>
                                                        <div className="field-value">
                                                            <H6 color="var(--primary-color)" fontWeight={400}>
                                                                BK-0001
                                                            </H6>
                                                        </div>
                                                    </div>

                                                    <div className="invoice-detail-container">
                                                        <div className="field-label">
                                                            <H6 color="var(--primary-color)" fontWeight={400}>
                                                                No of tickets:
                                                            </H6>
                                                        </div>
                                                        <div className="field-value">
                                                            <H6 color="var(--primary-color)" fontWeight={400}>
                                                                3
                                                            </H6>
                                                        </div>
                                                    </div>

                                                </div>
                                            </div>

                                            <div className="issue-by-container">

                                                <div className="issue-by-details">

                                                    <div className="invoice-detail-container">
                                                        <div className="field-label">
                                                            <H6 color="var(--primary-color)" fontWeight={400}>
                                                                Booked On:
                                                            </H6>
                                                        </div>
                                                        <div className="field-value">
                                                            <H6 color="var(--primary-color)" fontWeight={400}>
                                                                01/01/2024
                                                            </H6>
                                                        </div>
                                                    </div>

                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                </section>
                            </div>

                            {/* <!-- Page 2 --> */}
                            <div className="page page-break-before-always">
                                <section className="tax-invoice-container" style={{ gap: '0.5rem' }}>
                                    <H4 color="var(--primary-color)" fontWeight={600}>
                                        Payment Breakup
                                    </H4>

                                    <div className="payment-breakup-ticket-details">
                                        <H5 color="var(--primary-color)" fontWeight={600}>
                                            Booking Fees
                                        </H5>

                                        <table className="ticket-detail-breakup">

                                            <thead>
                                                <tr>
                                                    <th
                                                        className="td-left first-column-left-border right-border left-border bottom-border border-top">
                                                        <H7 color="var(--primary-color)" fontWeight={500}>
                                                            Ticket Name
                                                        </H7>
                                                    </th>
                                                    <th className="td-center right-border bottom-border border-top">
                                                        <H7 color="var(--primary-color)" fontWeight={500}>
                                                            Price
                                                        </H7>
                                                    </th>
                                                    <th className="td-center right-border bottom-border border-top">
                                                        <H7 color="var(--primary-color)" fontWeight={500}>
                                                            Charges
                                                        </H7>
                                                    </th>
                                                    <th className="td-center right-border bottom-border border-top">
                                                        <H7 color="var(--primary-color)" fontWeight={500}>
                                                            Qty
                                                        </H7>
                                                    </th>
                                                    <th
                                                        className="td-center last-column-right-border right-border bottom-border border-top">
                                                        <H7 color="var(--primary-color)" fontWeight={500}>
                                                            Total
                                                        </H7>
                                                    </th>
                                                </tr>
                                            </thead>

                                            <tbody>

                                                <tr>
                                                    <td
                                                        className="td-left td-bottom-border td-padding ticket-name-td right-border left-border">
                                                        <Body2 color="var(--primary-color)" fontWeight={400}>
                                                            General Admission Ticket
                                                        </Body2>
                                                    </td>
                                                    <td className="td-center td-bottom-border td-padding right-border">
                                                        <Body2 color="var(--primary-color)" fontWeight={400}>
                                                            ₹500.00
                                                        </Body2>
                                                    </td>
                                                    <td className="td-center td-bottom-border td-padding right-border">
                                                        <Body2 color="var(--primary-color)" fontWeight={400}>
                                                            ₹2
                                                        </Body2>
                                                    </td>
                                                    <td className="td-center td-bottom-border td-padding right-border">
                                                        <Body2 color="var(--primary-color)" fontWeight={400}>
                                                            2
                                                        </Body2>
                                                    </td>
                                                    <td className="td-center td-bottom-border td-padding right-border">
                                                        <Body2 color="var(--primary-color)" fontWeight={400}>
                                                            ₹950.00
                                                        </Body2>
                                                    </td>
                                                </tr>

                                                <tr>
                                                    <td
                                                        className="td-left td-bottom-border td-padding ticket-name-td right-border left-border">
                                                        <Body2 color="var(--primary-color)" fontWeight={400}>
                                                            General Admission Ticket
                                                        </Body2>
                                                    </td>
                                                    <td className="td-center td-bottom-border td-padding right-border">
                                                        <Body2 color="var(--primary-color)" fontWeight={400}>
                                                            ₹500.00
                                                        </Body2>
                                                    </td>
                                                    <td className="td-center td-bottom-border td-padding right-border">
                                                        <Body2 color="var(--primary-color)" fontWeight={400}>
                                                            ₹2
                                                        </Body2>
                                                    </td>
                                                    <td className="td-center td-bottom-border td-padding right-border">
                                                        <Body2 color="var(--primary-color)" fontWeight={400}>
                                                            2
                                                        </Body2>
                                                    </td>
                                                    <td className="td-center td-bottom-border td-padding right-border">
                                                        <Body2 color="var(--primary-color)" fontWeight={400}>
                                                            ₹950.00
                                                        </Body2>
                                                    </td>
                                                </tr>

                                                <tr>
                                                    <td colSpan="6" className="blank-row td-bottom-border">
                                                    </td>
                                                </tr>

                                                <tr>
                                                    <td colSpan="4" align="right"
                                                        className="td-bottom-border td-padding left-border right-border">
                                                        <Body2 color="var(--primary-color)" fontWeight={600}>
                                                            Booking Fees (Exclusive Tax)
                                                        </Body2>
                                                    </td>
                                                    <td className="td-center td-bottom-border td-padding right-border">
                                                        <Body2 color="var(--primary-color)" fontWeight={400}>
                                                            ₹950.00
                                                        </Body2>
                                                    </td>
                                                </tr>

                                                <tr>
                                                    <td colSpan="6" className="blank-row td-bottom-border">
                                                    </td>
                                                </tr>

                                                <tr>
                                                    <td colSpan="2" align="right"
                                                        className="td-bottom-border td-padding left-border right-border">
                                                    </td>
                                                    <td className="td-center td-bottom-border td-padding right-border"
                                                        colSpan="3">
                                                        <Body2 color="var(--primary-color)" fontWeight={600}>
                                                            Tax
                                                        </Body2>
                                                    </td>
                                                </tr>

                                                <tr>
                                                    <td colSpan="2" align="right"
                                                        className="td-bottom-border td-padding left-border right-border">
                                                    </td>
                                                    <td className="td-center td-bottom-border td-padding right-border"
                                                        colSpan="2">
                                                        <Body2 color="var(--primary-color)" fontWeight={400}>
                                                            IGST @ 18%
                                                        </Body2>
                                                    </td>
                                                    <td className="td-center td-bottom-border td-padding right-border">
                                                        <Body2 color="var(--primary-color)" fontWeight={400}>
                                                            ₹950.00
                                                        </Body2>
                                                    </td>
                                                </tr>

                                                <tr>
                                                    <td colSpan="2" align="right"
                                                        className="td-bottom-border td-padding left-border right-border">
                                                    </td>
                                                    <td className="td-center td-bottom-border td-padding right-border"
                                                        colSpan="2">
                                                        <Body2 color="var(--primary-color)" fontWeight={400}>
                                                            CGST @ 18%
                                                        </Body2>
                                                    </td>
                                                    <td className="td-center td-bottom-border td-padding right-border">
                                                        <Body2 color="var(--primary-color)" fontWeight={400}>
                                                            ₹950.00
                                                        </Body2>
                                                    </td>
                                                </tr>

                                                <tr>
                                                    <td colSpan="2" align="right"
                                                        className="td-bottom-border td-padding left-border right-border">
                                                    </td>
                                                    <td className="td-center td-bottom-border td-padding right-border"
                                                        colSpan="2">
                                                        <Body2 color="var(--primary-color)" fontWeight={400}>
                                                            SGST @ 18%
                                                        </Body2>
                                                    </td>
                                                    <td className="td-center td-bottom-border td-padding right-border">
                                                        <Body2 color="var(--primary-color)" fontWeight={400}>
                                                            ₹950.00
                                                        </Body2>
                                                    </td>
                                                </tr>

                                                <tr>
                                                    <td colSpan="2" align="right"
                                                        className="td-bottom-border td-padding left-border right-border">
                                                    </td>
                                                    <td className="td-center td-bottom-border td-padding right-border"
                                                        colSpan="2">
                                                        <Body2 color="var(--primary-color)" fontWeight={400}>
                                                            UTGST @ 18%
                                                        </Body2>
                                                    </td>
                                                    <td className="td-center td-bottom-border td-padding right-border">
                                                        <Body2 color="var(--primary-color)" fontWeight={400}>
                                                            ₹950.00
                                                        </Body2>
                                                    </td>
                                                </tr>

                                                <tr>
                                                    <td colSpan="6" className="blank-row td-bottom-border">
                                                    </td>
                                                </tr>

                                                <tr>
                                                    <td colSpan="4" align="right"
                                                        className="td-bottom-border td-padding left-border right-border">
                                                        <Body2 color="var(--primary-color)" fontWeight={600}>
                                                            Booking Fees (Inclusive Tax)
                                                        </Body2>
                                                    </td>
                                                    <td className="td-center td-bottom-border td-padding right-border">
                                                        <Body2 color="var(--primary-color)" fontWeight={400}>
                                                            ₹950.00
                                                        </Body2>
                                                    </td>
                                                </tr>

                                                <tr>
                                                    <td colSpan="6"
                                                        className="blank-row td-bottom-border last-column-bottom-left-border last-column-bottom-right-border">
                                                    </td>
                                                </tr>

                                            </tbody>

                                        </table>
                                    </div>

                                    <div className="notes-container">
                                        <H6 color="var(--primary-color)" fontWeight={600}>
                                            Fees:
                                        </H6>
                                        <ul>
                                            <Body2 color="var(--primary-color)" fontWeight={400}>
                                                <li>
                                                    ₹10 /- per ticket on tickets priced between ₹100 & ₹500.
                                                </li>
                                            </Body2>
                                            <Body2 color="var(--primary-color)" fontWeight={400}>
                                                <li>
                                                    2% per ticket on tickets priced less than ₹100 & greater than ₹500.
                                                </li>
                                            </Body2>
                                        </ul>
                                    </div>
                                </section>
                            </div>

                            {/* <!-- Page 3 --> */}
                            <div className="page page-break-before-always">
                                <section className="tax-invoice-container" style={{ gap: '0.5rem' }}>
                                    <H4 color="var(--primary-color)" fontWeight={600}>
                                        Payment Breakup
                                    </H4>

                                    <div className="payment-breakup-ticket-details">
                                        <H5 color="var(--primary-color)" fontWeight={600}>
                                            Platform Fees
                                        </H5>

                                        <table className="ticket-detail-breakup">

                                            <thead>
                                                <tr>
                                                    <th
                                                        className="td-left first-column-left-border right-border left-border bottom-border border-top">
                                                        <H7 color="var(--primary-color)" fontWeight={500}>
                                                            Description
                                                        </H7>
                                                    </th>
                                                    <th className="td-center right-border bottom-border border-top">
                                                        <H7 color="var(--primary-color)" fontWeight={500}>
                                                            Charges
                                                        </H7>
                                                    </th>
                                                    <th className="td-center right-border bottom-border border-top">
                                                        <H7 color="var(--primary-color)" fontWeight={500}>
                                                            Qty
                                                        </H7>
                                                    </th>
                                                    <th className="td-center right-border bottom-border border-top">
                                                        <H7 color="var(--primary-color)" fontWeight={500}>
                                                            Gross Ticket Price
                                                        </H7>
                                                    </th>
                                                    {/* <th className="td-center right-border bottom-border border-top">
                                                        <H7 color="var(--primary-color)" fontWeight={500}>
                                                            Charges
                                                        </H7>
                                                    </th> */}
                                                    <th
                                                        className="td-center last-column-right-border right-border bottom-border border-top" colSpan="2">
                                                        <H7 color="var(--primary-color)" fontWeight={500}>
                                                            Total
                                                        </H7>
                                                    </th>
                                                </tr>
                                            </thead>

                                            <tbody>

                                                <tr>
                                                    <td
                                                        className="td-left td-bottom-border td-padding ticket-name-td right-border left-border">
                                                        <Body2 color="var(--primary-color)" fontWeight={400}>
                                                            Platform Commission
                                                        </Body2>
                                                    </td>
                                                    <td className="td-center td-bottom-border td-padding right-border">
                                                        <Body2 color="var(--primary-color)" fontWeight={400}>
                                                            3%
                                                        </Body2>
                                                    </td>
                                                    <td className="td-center td-bottom-border td-padding right-border">
                                                        <Body2 color="var(--primary-color)" fontWeight={400}>
                                                            2
                                                        </Body2>
                                                    </td>
                                                    <td className="td-center td-bottom-border td-padding right-border">
                                                        <Body2 color="var(--primary-color)" fontWeight={400}>
                                                            ₹200.00
                                                        </Body2>
                                                    </td>
                                                    {/* <td className="td-center td-bottom-border td-padding right-border">
                                                        <Body2 color="var(--primary-color)" fontWeight={400}>
                                                            ₹95.00
                                                        </Body2>
                                                    </td> */}
                                                    <td className="td-center td-bottom-border td-padding right-border" colSpan="2">
                                                        <Body2 color="var(--primary-color)" fontWeight={400}>
                                                            ₹950.00
                                                        </Body2>
                                                    </td>
                                                </tr>

                                                <tr>
                                                    <td
                                                        className="td-left td-bottom-border td-padding ticket-name-td right-border left-border">
                                                        <Body2 color="var(--primary-color)" fontWeight={400}>
                                                            Service Fee
                                                        </Body2>
                                                    </td>
                                                    <td className="td-center td-bottom-border td-padding right-border">
                                                        <Body2 color="var(--primary-color)" fontWeight={400}>
                                                            ₹8.00
                                                        </Body2>
                                                    </td>
                                                    <td className="td-center td-bottom-border td-padding right-border">
                                                        <Body2 color="var(--primary-color)" fontWeight={400}>
                                                            2
                                                        </Body2>
                                                    </td>
                                                    <td className="td-center td-bottom-border td-padding right-border">
                                                        <Body2 color="var(--primary-color)" fontWeight={400}>
                                                            ₹110.00
                                                        </Body2>
                                                    </td>
                                                    {/* <td className="td-center td-bottom-border td-padding right-border">
                                                        <Body2 color="var(--primary-color)" fontWeight={400}>
                                                            ₹95.00
                                                        </Body2>
                                                    </td> */}
                                                    <td className="td-center td-bottom-border td-padding right-border" colSpan="2">
                                                        <Body2 color="var(--primary-color)" fontWeight={400}>
                                                            ₹950.00
                                                        </Body2>
                                                    </td>
                                                </tr>

                                                <tr>
                                                    <td colSpan="6" className="blank-row td-bottom-border">
                                                    </td>
                                                </tr>

                                                <tr>
                                                    <td colSpan="5" align="right"
                                                        className="td-bottom-border td-padding left-border right-border">
                                                        <Body2 color="var(--primary-color)" fontWeight={600}>
                                                            {/* Platform Fees (Exclusive Tax) */}
                                                            Gross Total
                                                        </Body2>
                                                    </td>
                                                    <td className="td-center td-bottom-border td-padding right-border">
                                                        <Body2 color="var(--primary-color)" fontWeight={400}>
                                                            ₹950.00
                                                        </Body2>
                                                    </td>
                                                </tr>

                                                <tr>
                                                    <td colSpan="6" className="blank-row td-bottom-border">
                                                    </td>
                                                </tr>

                                                <tr>
                                                    <td colSpan="3" align="right"
                                                        className="td-bottom-border td-padding left-border right-border">
                                                    </td>
                                                    <td className="td-center td-bottom-border td-padding right-border"
                                                        colSpan="3">
                                                        <Body2 color="var(--primary-color)" fontWeight={600}>
                                                            Tax
                                                        </Body2>
                                                    </td>
                                                </tr>

                                                <tr>
                                                    <td colSpan="3" align="right"
                                                        className="td-bottom-border td-padding left-border right-border">
                                                    </td>
                                                    <td className="td-center td-bottom-border td-padding right-border"
                                                        colSpan="2">
                                                        <Body2 color="var(--primary-color)" fontWeight={400}>
                                                            IGST @ 18%
                                                        </Body2>
                                                    </td>
                                                    <td className="td-center td-bottom-border td-padding right-border">
                                                        <Body2 color="var(--primary-color)" fontWeight={400}>
                                                            ₹950.00
                                                        </Body2>
                                                    </td>
                                                </tr>

                                                <tr>
                                                    <td colSpan="3" align="right"
                                                        className="td-bottom-border td-padding left-border right-border">
                                                    </td>
                                                    <td className="td-center td-bottom-border td-padding right-border"
                                                        colSpan="2">
                                                        <Body2 color="var(--primary-color)" fontWeight={400}>
                                                            CGST @ 18%
                                                        </Body2>
                                                    </td>
                                                    <td className="td-center td-bottom-border td-padding right-border">
                                                        <Body2 color="var(--primary-color)" fontWeight={400}>
                                                            ₹950.00
                                                        </Body2>
                                                    </td>
                                                </tr>

                                                <tr>
                                                    <td colSpan="3" align="right"
                                                        className="td-bottom-border td-padding left-border right-border">
                                                    </td>
                                                    <td className="td-center td-bottom-border td-padding right-border"
                                                        colSpan="2">
                                                        <Body2 color="var(--primary-color)" fontWeight={400}>
                                                            SGST @ 18%
                                                        </Body2>
                                                    </td>
                                                    <td className="td-center td-bottom-border td-padding right-border">
                                                        <Body2 color="var(--primary-color)" fontWeight={400}>
                                                            ₹950.00
                                                        </Body2>
                                                    </td>
                                                </tr>

                                                <tr>
                                                    <td colSpan="3" align="right"
                                                        className="td-bottom-border td-padding left-border right-border">
                                                    </td>
                                                    <td className="td-center td-bottom-border td-padding right-border"
                                                        colSpan="2">
                                                        <Body2 color="var(--primary-color)" fontWeight={400}>
                                                            UTGST @ 18%
                                                        </Body2>
                                                    </td>
                                                    <td className="td-center td-bottom-border td-padding right-border">
                                                        <Body2 color="var(--primary-color)" fontWeight={400}>
                                                            ₹950.00
                                                        </Body2>
                                                    </td>
                                                </tr>

                                                <tr>
                                                    <td colSpan="6" className="blank-row td-bottom-border">
                                                    </td>
                                                </tr>

                                                <tr>
                                                    <td colSpan="5" align="right"
                                                        className="td-bottom-border td-padding left-border right-border">
                                                        <Body2 color="var(--primary-color)" fontWeight={600}>
                                                            Platform Fees (Inclusive Tax)
                                                        </Body2>
                                                    </td>
                                                    <td className="td-center td-bottom-border td-padding right-border">
                                                        <Body2 color="var(--primary-color)" fontWeight={400}>
                                                            ₹950.00
                                                        </Body2>
                                                    </td>
                                                </tr>

                                                <tr>
                                                    <td colSpan="6"
                                                        className="blank-row td-bottom-border last-column-bottom-left-border last-column-bottom-right-border">
                                                    </td>
                                                </tr>

                                            </tbody>

                                        </table>
                                    </div>

                                    <div className="notes-container" style={{ marginTop: '1rem' }}>
                                        <H6 color="var(--primary-color)" fontWeight={600}>
                                            Fees:
                                        </H6>
                                        <ul>
                                            <Body2 color="var(--primary-color)" fontWeight={400}>
                                                <li>
                                                    Commission on total gross sale: 3%.
                                                </li>
                                            </Body2>
                                            <Body2 color="var(--primary-color)" fontWeight={400}>
                                                <li>
                                                    Service fee on all tickets price ₹100 or more: ₹8/-
                                                </li>
                                            </Body2>
                                        </ul>
                                    </div>

                                    <div className="notes-container" style={{ marginTop: '1rem' }}>
                                        <H6 color="var(--primary-color)" fontWeight={600}>
                                            Note:
                                        </H6>
                                        <ul>
                                            <Body2 color="var(--primary-color)" fontWeight={400}>
                                                <li>
                                                    Total quantity of tickets price ₹100 or above: 50.
                                                </li>
                                            </Body2>
                                        </ul>
                                    </div>
                                </section>
                            </div>


                            {/* <!-- Page 4 --> */}
                            <div className="page page-break-before-always">
                                <section className="tax-invoice-container">
                                    <div className="payment-summary-container">
                                        <H4 color="var(--primary-color)" fontWeight={600}>
                                            Payment Summary
                                        </H4>

                                        <div className="payment-breakup-ticket-details">

                                            <table className="ticket-detail-breakup">

                                                <thead>
                                                    <tr>
                                                        <th className="td-center first-column-left-border right-border left-border border-top bottom-border"
                                                            style={{ width: '50%' }}>
                                                            <H7 color="var(--primary-color)" fontWeight={500}>
                                                                Description
                                                            </H7>
                                                        </th>
                                                        <th className="td-center last-column-right-border right-border border-top bottom-border"
                                                            style={{ width: '50%' }}>
                                                            <H7 color="var(--primary-color)" fontWeight={500}>
                                                                Amount
                                                            </H7>
                                                        </th>
                                                    </tr>
                                                </thead>

                                                <tbody>

                                                    <tr>
                                                        <td
                                                            className="td-center td-bottom-border td-padding ticket-name-td right-border left-border">
                                                            <Body2 color="var(--primary-color)" fontWeight={400}>
                                                                Total amount exclusive tax
                                                            </Body2>
                                                        </td>
                                                        <td className="td-center td-bottom-border td-padding right-border">
                                                            <Body2 color="var(--primary-color)" fontWeight={400}>
                                                                ₹950.00
                                                            </Body2>
                                                        </td>
                                                    </tr>

                                                    <tr>
                                                        <td
                                                            className="td-center td-bottom-border td-padding ticket-name-td right-border left-border">
                                                            <Body2 color="var(--primary-color)" fontWeight={400}>
                                                                CGST @ 9%
                                                            </Body2>
                                                        </td>
                                                        <td className="td-center td-bottom-border td-padding right-border">
                                                            <Body2 color="var(--primary-color)" fontWeight={400}>
                                                                ₹950.00
                                                            </Body2>
                                                        </td>
                                                    </tr>

                                                    <tr>
                                                        <td
                                                            className="td-center td-bottom-border td-padding ticket-name-td right-border left-border">
                                                            <Body2 color="var(--primary-color)" fontWeight={400}>
                                                                SGST @ 9%
                                                            </Body2>
                                                        </td>
                                                        <td className="td-center td-bottom-border td-padding right-border">
                                                            <Body2 color="var(--primary-color)" fontWeight={400}>
                                                                ₹950.00
                                                            </Body2>
                                                        </td>
                                                    </tr>

                                                    <tr>
                                                        <td
                                                            className="td-center td-bottom-border td-padding ticket-name-td right-border left-border">
                                                            <Body2 color="var(--primary-color)" fontWeight={400}>
                                                                IGST @ 18%
                                                            </Body2>
                                                        </td>
                                                        <td className="td-center td-bottom-border td-padding right-border">
                                                            <Body2 color="var(--primary-color)" fontWeight={400}>
                                                                ₹950.00
                                                            </Body2>
                                                        </td>
                                                    </tr>

                                                    <tr>
                                                        <td
                                                            className="td-center td-bottom-border td-padding ticket-name-td right-border left-border">
                                                            <Body2 color="var(--primary-color)" fontWeight={400}>
                                                                UTGST @ 18%
                                                            </Body2>
                                                        </td>
                                                        <td className="td-center td-bottom-border td-padding right-border">
                                                            <Body2 color="var(--primary-color)" fontWeight={400}>
                                                                ₹950.00
                                                            </Body2>
                                                        </td>
                                                    </tr>

                                                    <tr>
                                                        <td colSpan="6" className="blank-row td-bottom-border">
                                                        </td>
                                                    </tr>

                                                    <tr>
                                                        <td
                                                            className="td-bottom-border td-padding left-border right-border td-center">
                                                            <Body2 color="var(--primary-color)" fontWeight={600}>
                                                                Total amount: GST:
                                                            </Body2>
                                                        </td>
                                                        <td className="td-center td-bottom-border td-padding right-border">
                                                            <Body2 color="var(--primary-color)" fontWeight={400}>
                                                                ₹950.00
                                                            </Body2>
                                                        </td>
                                                    </tr>

                                                    <tr>
                                                        <td
                                                            className="td-bottom-border td-padding left-border right-border td-center">
                                                            <Body2 color="var(--primary-color)" fontWeight={600}>
                                                                Total amount inclusive tax:
                                                            </Body2>
                                                        </td>
                                                        <td className="td-center td-bottom-border td-padding right-border">
                                                            <Body2 color="var(--primary-color)" fontWeight={400}>
                                                                ₹950.00
                                                            </Body2>
                                                        </td>
                                                    </tr>

                                                    <tr>
                                                        <td colSpan="6"
                                                            className="blank-row td-bottom-border last-column-bottom-left-border last-column-bottom-right-border">
                                                        </td>
                                                    </tr>

                                                </tbody>

                                            </table>
                                        </div>
                                    </div>

                                    <div className="hr"></div>

                                    <div className="payment-breakup-ticket-details">

                                        <table className="ticket-detail-breakup">

                                            <tbody>

                                                <tr>
                                                    <td className="td-bottom-border td-padding left-border right-border td-center top-border"
                                                        style={{ width: '30%' }}>
                                                        <Body2 color="var(--primary-color)" fontWeight={600}>
                                                            Total amount in words
                                                        </Body2>
                                                    </td>
                                                    <td className="td-left td-bottom-border td-padding right-border top-border">
                                                        <Body2 color="var(--primary-color)" fontWeight={400}>
                                                            Nine Hundred Fifty Rupees Only
                                                        </Body2>
                                                    </td>
                                                </tr>

                                            </tbody>

                                        </table>

                                        <table className="ticket-detail-breakup">

                                            <tbody>

                                                <tr>
                                                    <td className="td-bottom-border td-padding left-border right-border td-center top-border"
                                                        style={{ width: '30%' }}>
                                                        <Body2 color="var(--primary-color)" fontWeight={600}>
                                                            Authorized Signature
                                                        </Body2>
                                                    </td>
                                                    <td className="td-left td-bottom-border td-padding right-border top-border">
                                                        <Body2 color="var(--primary-color)" fontWeight={400}>
                                                            This is a digitally generated invoice & does not require a
                                                            digital signature.
                                                        </Body2>
                                                    </td>
                                                </tr>

                                            </tbody>

                                        </table>
                                    </div>

                                    <div className="hr"></div>

                                    <div className="invoice-details-container">
                                        <H4 color="var(--primary-color)" fontWeight={600}>
                                            Payment Details
                                        </H4>

                                        <div className="tax-invoice-persons-container">
                                            <div className="issue-by-container">

                                                <div className="issue-by-details">

                                                    <div className="invoice-detail-container">
                                                        <div className="field-label">
                                                            <H6 color="var(--primary-color)" fontWeight={400}>
                                                                Transaction ID:
                                                            </H6>
                                                        </div>
                                                        <div className="field-value">
                                                            <H6 color="var(--primary-color)" fontWeight={400}>
                                                                TXN123456789
                                                            </H6>
                                                        </div>
                                                    </div>

                                                    <div className="invoice-detail-container">
                                                        <div className="field-label">
                                                            <H6 color="var(--primary-color)" fontWeight={400}>
                                                                Paid On:
                                                            </H6>
                                                        </div>
                                                        <div className="field-value">
                                                            <H6 color="var(--primary-color)" fontWeight={400}>
                                                                01/01/2024
                                                            </H6>
                                                        </div>
                                                    </div>

                                                </div>
                                            </div>

                                            <div className="issue-by-container">

                                                <div className="issue-by-details">

                                                    <div className="invoice-detail-container">
                                                        <div className="field-label">
                                                            <H6 color="var(--primary-color)" fontWeight={400}>
                                                                Payment Method:
                                                            </H6>
                                                        </div>
                                                        <div className="field-value">
                                                            <H6 color="var(--primary-color)" fontWeight={400}>
                                                                Credit Card
                                                            </H6>
                                                        </div>
                                                    </div>

                                                    <div className="invoice-detail-container">
                                                        <div className="field-label">
                                                            <H6 color="var(--primary-color)" fontWeight={400}>
                                                                Amount Paid:
                                                            </H6>
                                                        </div>
                                                        <div className="field-value">
                                                            <H6 color="var(--primary-color)" fontWeight={400}>
                                                                ₹950.00
                                                            </H6>
                                                        </div>
                                                    </div>

                                                </div>
                                            </div>
                                        </div>

                                        <table className="ticket-detail-breakup">

                                            <tbody>

                                                <tr>
                                                    <td className="td-bottom-border td-padding left-border right-border td-left top-border"
                                                        style={{ width: '30%' }}>
                                                        <Body2 color="var(--primary-color)" fontWeight={600}>
                                                            Amount paid in words
                                                        </Body2>
                                                    </td>
                                                    <td className="td-left td-bottom-border td-padding right-border top-border"
                                                        style={{ width: '30%' }}>
                                                        <Body2 color="var(--primary-color)" fontWeight={400}>
                                                            Nine Hundred Fifty Rupees Only
                                                        </Body2>
                                                    </td>
                                                </tr>

                                            </tbody>

                                        </table>
                                    </div>

                                    {/* <!-- <div className="hr"></div> --> */}

                                    <div className="notes-container">
                                        <H6 color="var(--primary-color)" fontWeight={600}>
                                            Notes:
                                        </H6>
                                        <ul>
                                            <Body2 color="var(--primary-color)" fontWeight={400}>
                                                <li>
                                                    Value of ₹[ Total ticket price incl. tax ] /- pertains to services provided
                                                    by [ event creator name]. Refer to invoice number : [ Ticket invoice number
                                                    ]
                                                </li>
                                            </Body2>
                                        </ul>
                                    </div>
                                </section>
                            </div>

                        </td>
                    </tr>
                </tbody>

                <tfoot>
                    <tr>
                        <td>
                            <div className="footer-space"></div>
                        </td>
                    </tr>
                </tfoot>

            </table >

            <footer id="invoice-footer-container">
                <div className="company-detail-footer">
                    <div className="company-footer">
                        <Body3 color="var(--primary-color)" fontWeight={400}>
                            Details of ECO under GST
                        </Body3>
                        <Body3 color="var(--primary-color)" fontWeight={400}>
                            {companyName} (Shmooz)
                        </Body3>
                        <Body3 color="var(--primary-color)" fontWeight={400}>
                            {companyAddress}
                        </Body3>
                        <Body3 color="var(--primary-color)" fontWeight={400}>
                            GSTIN: {companyGSTIN}
                        </Body3>
                    </div>
                </div>
            </footer>

        </main >
    )
}